<template>
	<div v-if="user">
		<router-view
			:user="user"
			:isAuth="isAuth">
		</router-view>
	</div>
</template>

<script>
	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/cms/categories/layout/Category.vue